import * as React from 'react';

import { observer } from 'mobx-react';
import moment from 'moment';

import { getErrorMessage } from 'common-utils';
import { showConfirmDialogWithoutCancel } from 'ui-lib';
import { ConstrainedDateRangePicker } from 'pages/private/components/constrained-date-range-picker';
import { DATE_TIME_FORMAT, DEFAULT_HISTORICAL_RANGE } from 'common-utils/date-utils';

import { DeviceLogsTable, exportDeviceLogs, getDeviceLogsColumn, IDeviceLogsProps, useDeviceLogsStore } from './device-log-table';
import { TableUtils } from 'pages/private/components/table-utils';

export const RaptorDeviceLogsComponent = observer((props: IDeviceLogsProps) => {
    const store = useDeviceLogsStore(props);

    const downloadLogFile = () => {
        try {
            const logType = store.defaultLogType;
            exportDeviceLogs(
                store,
                logType.toLowerCase(),
                store.displayDeviceLogs(logType).map((item) => item.data),
            );
        } catch (err) {
            showConfirmDialogWithoutCancel({
                title: 'Error',
                content: getErrorMessage(err),
                okText: 'OK',
            });
        }
    };

    return (
        <DeviceLogsTable
            store={store}
            columns={[
                TableUtils.createBasicFilterTimeColumn({
                    key: 'timestamp',
                    title: 'Timestamp',
                    columnExtraOptions: {
                        filterDropdown: undefined,
                        onFilter: undefined,
                        width: '200px'
                    },
                }),
                getDeviceLogsColumn(),
            ]}
            isProcessing={false}
            onDownload={downloadLogFile}
            datePicker={
                <ConstrainedDateRangePicker
                    key='date-range-picker'
                    range={DEFAULT_HISTORICAL_RANGE}
                    dateFormat={DATE_TIME_FORMAT.DATE_AND_SHORT_TIME}
                    showTime={true}
                    setFilterByDateFrom={(dateFrom: Date) => store.setDateFrom(moment(dateFrom))}
                    setFilterByDateTo={(dateTo: Date) => store.setDateTo(moment(dateTo))}
                    filterByDateFrom={store.dateFrom.toDate()}
                    filterByDateTo={store.dateTo.toDate()}
                    loading={store.loading}
                    onLoad={() => store.initialize(true)}
                />
            }
        />
    );
});
